module.exports = __webpack_public_path__ + "static/media/sidebar-account-manager.c4ba089f.svg";